import { render, staticRenderFns } from "./Treatments.vue?vue&type=template&id=50073969"
import script from "./Treatments.vue?vue&type=script&lang=js"
export * from "./Treatments.vue?vue&type=script&lang=js"
import style0 from "./Treatments.vue?vue&type=style&index=0&id=50073969&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports